import { useCallback, useState } from 'react'
import Button from 'components/Button'
import Spinner from 'components/Spinner'
import { useEmailPreview } from './use-email-preview'
import { CommsDataTypes } from 'types/comms'
import { resendEmails } from 'api/comms'
import { toast } from 'react-toastify'
import { useQueryClient } from 'react-query'
import { useCanUI } from 'hooks/useCanUI'

export const EmailPreview = ({
  commsData,
  onCloseModal,
}: {
  commsData: CommsDataTypes
  onCloseModal: () => void
}): JSX.Element => {
  const {
    isMemberCommsNZViewEmail,
    isMemberCommsNZResendEmail,
    isMemberCommsNZEditEmail,
  } = useCanUI()
  const [isHtmlView, isHtmlViewSet] = useState(true)
  const [isSending, setIsSending] = useState(false)
  const { data: dataEmailPreview, isLoading: isLodingEmailPreview } =
    useEmailPreview({ actionId: commsData.id })

  const handleViewToggle = useCallback(() => {
    isHtmlViewSet(!isHtmlView)
  }, [isHtmlView, isHtmlViewSet])

  const queryClient = useQueryClient()

  const handleResend = useCallback(async () => {
    setIsSending(true)
    try {
      await resendEmails(commsData.id)
      queryClient.invalidateQueries(['useComms'])
      toast.success('Email sent successfully')
      onCloseModal()
    } catch (error) {
      toast.error('Failed to resend email')
    }
    setIsSending(false)
  }, [commsData.id])

  const htmlTemplate = dataEmailPreview ? dataEmailPreview.htmlPreviewUrl : ''
  const textTemplate = dataEmailPreview ? dataEmailPreview.textPreviewUrl : ''
  const attrTemplates = dataEmailPreview
    ? Object.keys(dataEmailPreview.actionAttributes).map((item) => ({
        name: item,
        value: dataEmailPreview.actionAttributes[item],
      }))
    : []

  return (
    <>
      {isLodingEmailPreview ? (
        <div className="flex justify-center items-center h-52">
          <Spinner />
        </div>
      ) : (
        <div className="">
          <div className="mb-8 flex">
            {htmlTemplate && isMemberCommsNZViewEmail && (
              <Button
                onClick={handleViewToggle}
                iconRight={false}
                type="button"
                className="rounded bg-primary tracking-wider font-bold mr-2.5"
              >
                To {isHtmlView ? 'Text View' : 'HTML View'}
              </Button>
            )}

            {isMemberCommsNZResendEmail && (
              <Button
                onClick={handleResend}
                iconRight={false}
                type="button"
                disabled={isSending}
                className="rounded bg-primary tracking-wider font-bold"
              >
                {isSending ? 'Sending...' : 'Resend'}
              </Button>
            )}
          </div>
          {htmlTemplate ? (
            <div className="flex gap-8">
              <div className="w-full flex justify-center overflow-y-auto">
                {isHtmlView ? (
                  <div
                    className=" bg-white rounded-xl overflow-hidden w-full"
                    style={{ height: '700px' }}
                    dangerouslySetInnerHTML={{
                      __html: `<iframe src='${htmlTemplate}'  style="
                top: 0; left: 0; width: 100%; height: 100%;" />`,
                    }}
                  />
                ) : (
                  <div
                    className=" bg-white rounded-xl overflow-hidden w-full"
                    style={{ height: '700px' }}
                    dangerouslySetInnerHTML={{
                      __html: `<iframe src='${textTemplate}'  style="
                top: 0; left: 0; width: 100%; height: 100%;" />`,
                    }}
                  />
                )}
              </div>
              <div className="w-96 bg-gray-100 bg-opacity-40 rounded-2xl p-4 mb-10 min-h-96">
                <div className="">
                  <p className="text-lg tracking-wide font-bold mb-4">
                    Template Variables
                  </p>
                  <ul className=" flex flex-col">
                    {attrTemplates.map((item) => (
                      <li
                        key={item.name}
                        className="hover:bg-white py-2 px-2 cursor-pointer rounded-xl overflow-hidden"
                      >
                        <p className="font-bold text-black text-opacity-40  tracking-wide">
                          [{item.name}]
                        </p>
                        <p className="font font-bold tracking-wide">
                          {!item.value || item.value === ''
                            ? 'None'
                            : item.value}
                        </p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center text-gray-500 text-lg">
              Email Preview is unavailable
            </div>
          )}
        </div>
      )}
    </>
  )
}
